// @flow

import type { Dispatch } from 'redux';

import { OPEN_WHITEBOARD, CLOSE_WHITEBOARD } from './actionTypes';
import { setTileView } from '../video-layout';

declare var APP: Object;
var open = null;

export function openWhiteboard() {
    console.log('openWhiteboard',open)
    if(!open) {
        window.previousTileLayout = APP.store.getState()["features/video-layout"].tileViewEnabled;
        APP.store.dispatch(setTileView(false))
        open = true;
    }
    return {
        type: OPEN_WHITEBOARD
    }
}

export function closeWhiteboard() {
    if(!open) {
        return;
    }
    if(open) {
        APP.store.dispatch(setTileView(window.previousTileLayout, true))
        open = false;
    }
    if(window.isWhiteboardByMe){
        window.isWhiteboardByMe = false
    }
    return {
        type: CLOSE_WHITEBOARD
    };
}

/**
 * Toggles display of the chat panel.
 *
 * @returns {Function}
 */
export function toggleWhiteboard() {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const isOpen = getState()['features/whiteboard'].isOpen;

        // if (isOpen) {
        //     dispatch(closeWhiteboard());
        // } else {
        //     dispatch(openWhiteboard());
        // }

    };
}
